import styles from "./CopyButton.module.css";
import {useNotificationStore} from "../../../store/NotificationStore.ts";

const CopyButton = () => {

    const setNotification = useNotificationStore((state) => state.setNotification);

    const InviteLink = () => {
        const userId: number = window.Telegram?.WebApp.initDataUnsafe.user.id
        window.Telegram?.WebApp.openTelegramLink(`https://t.me/share/url?url=https://t.me/dreamcoin_bot?start=${userId}`)
    }

    const copyLink = () => {
        const userId: number = window.Telegram?.WebApp.initDataUnsafe.user.id

        navigator.clipboard.writeText(`https://t.me/dreamcoin_bot?start=${userId}`);

        setNotification({
            type: "Success",
            message: "Ссылка скопирована"
        })
    }

    return (
        <div className={styles.bottomInviteSection}>
            <button onClick={InviteLink} className={styles.inviteFriendButton}>Пригласить друга</button>
            <button onClick={copyLink} className={styles.copyButton}>
                <div className={styles.navIcon}/>
            </button>
        </div>
    )
}

export default CopyButton